/**
 * @fileoverview This is a higher order component that controls how
 * breakpoints are sent into components. In some cases, we want to
 * "lock" the breakpoint, so that small charts always display in the
 * small view.
 */

import React from 'react'
import { getBreakpoint } from './breakpoints'
import { string } from 'prop-types'

export default function withChartBreakpointFactory(Component) {
  class WithBreakpoint extends React.PureComponent {
    static contextTypes = {
      breakpoint: string
    }

    render() {
      const { width } = this.props

      let breakpoint = this.context.breakpoint || getBreakpoint(width)

      return React.createElement(Component, { ...this.props, breakpoint })
    }
  }

  return WithBreakpoint
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/with-chart-breakpoint.js